export default __webpack_public_path__ + "static/media/21.23d44685.jpg";